<template>
  <div style=" background-color: #F5F6FA;">
    <hear></hear>
    <div>
      <div class="Guarantee_status_box">
        <div class="Guarantee_examine">保函列表</div>

<div class="shenflex">
          <div
         
          v-for="item in BidingDocumentList"
          :key="item.id"
          style="display: flex;flex-direction: column;"
          class="Guarantee_status"
          @click="step_page(item)"
        >
          <div style="margin-left:20px;padding-top: 25px;" class="fl">
            <div style="display: flex;">
              <div style="color:#333333;font-size:24px;font-weight:bold;">{{ item.bidding_name }}</div>
              <div class="Ge_box">
                <div>{{item.gtype}}</div>
              </div>
            </div>
          </div>
          <div style="display: flex;" class="fl Guarantee_details">
            <div style="margin-top: 53px;display: flex;justify-content: center;" class="fl">
              <div>
                <img src="../../assets/Guarantee/file.png" />
              </div>
              <div style="margin-left:6px" class="Guarantee_num">
                标段编号：
                {{item.bidding_number}}
              </div>
            </div>
            <div style="margin-top: 53px;display: flex;justify-content: center;" class="fl">
              <div>
                <img src="../../assets/Guarantee/file.png" />
              </div>
              <div style="margin-left:6px">项目金额:{{}}</div>
            </div>
            <div style="margin-top: 53px;display: flex;justify-content: center;" class="fl">
              <div>
                <img src="../../assets/Guarantee/file.png" />
              </div>
              <div style="margin-left:6px">开标时间:{{item.create_time|dateFormat}}</div>
            </div>
            <div class="money">
              <div style="color:#FF184E;font-size:28px;font-weight: bold;">￥{{item.margin_amount}}</div>
              <div style="display: flex;    justify-content: center;">
                <div class="bubble">
                  <div style="margin-top:4px">项目金额</div>
                </div>
              </div>
            </div>
            <div
              class="state_bh"
              style="margin-top: 23px;"
            >{{item.state==0?'申请中':item.state==1?'审核中':item.state ==2?'审核通过':'审核不通过'}}</div>
          </div>
        </div>
</div>
      </div>
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentpage"
          :page-sizes="[4, 8, 12]"
          :page-size="params.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { bhlist } from "@/api/system/liucheng";
import hear from ".././../components/hear.vue";
export default {
  components: {
    hear
  },
  name: "progress",
  data() {
    return {
      total: null,
      currentpage: null,
      params: {
        limit: 4,
        offset: 0,
        keywords: "",
        user_id: sessionStorage.getItem("user_id")
      },
      BidingDocumentList: []
    };
  },
  mounted() {
    this.getBhlist();
  },
  methods: {
    getBhlist() {
      bhlist(this.params).then(res => {
        this.BidingDocumentList = res.data.data.rows
        this.total = res.data.data.total;
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.limit = val;
      this.getBhlist();
    },
    handleCurrentChange(val) {
      this.params.offset = parseInt(val - 1) * this.params.limit;
      this.currentpage = val;
      this.getBhlist();
    }
  }
};
</script>

<style scoped>
.block {
  padding: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.state_bh {
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #1890ff;
  width: 143px;
  height: 47px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  line-height: 47px;
  text-align: center;
  border: 2px solid #1890ff;
}
.shenflex{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.status_bg1 {
  width: 85px;
  height: 40px;
  background-color: #ff1818;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.status_bg {
  width: 85px;
  height: 40px;
  background-color: #1795ff;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.examine_btn {
  width: 143px;
  height: 47px;
  color: #1795ff;
}

.bubble {
  color: #ffffff;
  font-size: 12px;
  width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  margin-left: 20px;
  background-image: url("../../assets/Guarantee/Bubble.png");
}

.Guarantee_details {
  justify-content: space-around;
}

.Ge_box {
  width: 113px;
  height: 33px;
  border-radius: 4px;
  background-color: #1795ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-left: 15px;
}

.Guarantee_num {
  width: 219px;
  height: 48px;
  color: #333333;
}

.Guarantee_status_box {
  /* position: relative;
  top: 9%;
  left: 247px; */
}

.Guarantee_status {
  width: 95%;
  height: 162px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
}

.Guarantee_examine {
  color: #333333;
  font-size: 24px;
  margin-left: 30px;
  margin-top: 10px;
  font-weight: Bold;
  margin-bottom: 36px;
}
</style>



// WEBPACK FOOTER //
// src/view/progress/progress.vue